import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
    selector: '[clickExpander]',
    standalone: false
})
export class ClickDirective {
    @Output() doubleClick = new EventEmitter();
    @Output() shiftClick = new EventEmitter();
    @Output() ctrlClick = new EventEmitter();
    @Output() singleClick = new EventEmitter();
    // private _doubleClick: boolean = false;
    // private _timer = setInterval(() => {
    // })


    // @ts-ignore
    @HostListener('mousedown', ['$event']) determineClick($event: MouseEvent) {
        // clearInterval(this._timer)
        // if (this._doubleClick) {
        //     this._doubleClick = false
        //     this.doubleClick.emit($event)
        //     return
        // }
        //
        // if ($event.shiftKey) {
        //     this.shiftClick.emit($event)
        //     return;
        // }
        //
        // if ($event.ctrlKey) {
        //     this.ctrlClick.emit($event)
        //     return;
        // }
        //
        // this._doubleClick = true
        //
        // this._timer = setInterval(() => {
        //     this._doubleClick = false
        //     this.singleClick.emit($event)
        //     clearInterval(this._timer)
        // }, 50)
    }
}